import { z } from 'zod';
import type { PredicateIssue } from '@/shared/api';

/**
 * Схема значения поля условия.
 *
 * Пока в значении есть проблемы, форма с ним не сохраняется: пользователь либо
 * исправляет запись, либо очищает поле. Сами проблемы кладёт в значение поле ввода
 * условия, поэтому их состав тут не проверяется.
 *
 * @param issuesMessage — сообщение формы о непригодном условии
 */
export const createPredicateSchema = (issuesMessage: string) =>
  z
    .object({
      dsl: z.string().optional(),
      dslHuman: z.string().nullish(),
      issues: z.array(z.custom<PredicateIssue>()).optional(),
    })
    .refine((value) => !value.issues?.length, { error: issuesMessage });
